import { ComponentPublicInstance } from 'vue';

import { isHTMLElement } from '@sg-core/resources/assets/js/utils';

function isVueComponent(element: unknown): element is ComponentPublicInstance {
  return element !== null && typeof element === 'object' && '$el' in element;
}

function getElement(element: unknown): HTMLElement | null {
  if (isHTMLElement(element)) {
    return element;
  }

  if (isVueComponent(element)) {
    return element.$el;
  }

  return null;
}

type LoadingStateHelper = (element: HTMLElement) => void;

export function patchedLoadingState(original: LoadingStateHelper) {
  return (element: unknown) => {
    const el = getElement(element);

    if (!el) {
      console.warn('[Phxsg LoadingState]: Element not found');
      return;
    }

    original(el);
  };
}
